import '../../../webpack_public_path';
import React from 'react';
import ReactDom from 'react-dom';
import { ThemeProvider } from 'styled-components';
import { Provider as StoreProvider } from 'react-redux';
import { BrowserRouter as Router } from 'react-router-dom';
import { loadableReady } from '@loadable/component';
import Cookies from 'universal-cookie';
import theme from '../../GlobalStyles/theme';
import configureStore, { createDependencies } from '../../../redux/store';
import OneHeaderMicroApp from './index';
import getConfig from 'Client/globals/config';
import { FetchManagerProvider } from 'Client/hooks/useFetchingAction/FetchManagerContext';
import ClientFetchActionManager from 'Client/hooks/useFetchingAction/ClientFetchActionManager';
import { GaTrackingProvider } from 'Client/hooks/useGa';
import GaTracking from 'Common/ga';
import { DataLayerManagerType } from 'Common/ga/dataLayerManager/dataLayerManagerFactory';
import { DataLayerPlatform } from 'Common/ga/dataLayerManager/serverDataLayerManager';
import EventListener from 'Common/events';
import { createCustomEvents } from 'Common/events/create';
import { ConfigProvider, FeatureToggleProvider, SegmentsProvider, TranslationProvider } from 'Common/providers';
import { Segments } from 'Common/types/segments';
import { FeatureToggles, Config } from 'Common/appshell_types';
import { getLoggedInUserData } from 'Client/redux/user/actions';
import { exposeStringFeatureToggleOptions } from 'Client/exposeStringFeatureToggleOptions';
import { SegmentTracker } from 'Common/segment';

const {
    translations,
    featureToggles,
    segments,
    language,
    country,
    initialState,
    location: { origin },
    clientLogger,
} = window;

const config: Config = getConfig();

const segmentTracker = new SegmentTracker({
    writeKey: config.segmentWriteKey,
    enabled: (featureToggles as FeatureToggles)?.shopSegmentIntegration,
    logger: clientLogger,
});
const gaTracking = new GaTracking({
    type: DataLayerManagerType.CLIENT_WITH_NO_DELAY,
    trackingConfig: {
        currency: config.currency,
        platform: DataLayerPlatform.NONE,
    },
    logger: clientLogger,
    segmentTracker,
});

const { userAgent } = navigator;
const store = configureStore(
    initialState || {},
    createDependencies({
        shopApiBaseUrl: config.shopApiBaseUrl,
        config,
        logger: clientLogger,
        country,
        userAgent,
        location: window.location,
        segmentTracker,
    })
);

const events = createCustomEvents({
    dispatch: store.dispatch,
    config,
    cookies: new Cookies(),
    featureToggles,
    braze: null,
});
EventListener(events);

const fetchingManager = new ClientFetchActionManager();

/* Need this to expose string FT options to FT browser extension */
window.getStringFeatureToggles = exposeStringFeatureToggleOptions;

window.addEventListener('pageshow', () => {
    store.dispatch(getLoggedInUserData());
});

loadableReady(() => {
    ReactDom.hydrate(
        <FetchManagerProvider value={fetchingManager}>
            <SegmentsProvider value={segments as Segments}>
                <ThemeProvider theme={theme}>
                    <TranslationProvider translations={translations?.data || {}} language={language}>
                        <FeatureToggleProvider value={featureToggles as FeatureToggles}>
                            <ConfigProvider initialConfig={config as Config}>
                                <StoreProvider store={store}>
                                    <GaTrackingProvider value={gaTracking}>
                                        <Router>
                                            <OneHeaderMicroApp detachedHeaderMode host={origin} />
                                        </Router>
                                    </GaTrackingProvider>
                                </StoreProvider>
                            </ConfigProvider>
                        </FeatureToggleProvider>
                    </TranslationProvider>
                </ThemeProvider>
            </SegmentsProvider>
        </FetchManagerProvider>,
        document.querySelector('#wwOneHeader')
    );
});
